var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuiastiss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18H12.75V17H14.25C14.4625 17 14.6406 16.9281 14.7844 16.7844C14.9281 16.6406 15 16.4625 15 16.25V13C15 12.7875 14.9281 12.6094 14.7844 12.4656C14.6406 12.3219 14.4625 12.25 14.25 12.25H10.5V10.5H15V9H12.75V8H11.25V9H9.75C9.5375 9 9.35938 9.07188 9.21563 9.21563C9.07188 9.35938 9 9.5375 9 9.75V13C9 13.2125 9.07188 13.3906 9.21563 13.5344C9.35938 13.6781 9.5375 13.75 9.75 13.75H13.5V15.5H9V17H11.25V18ZM5.5 22C5.1 22 4.75 21.85 4.45 21.55C4.15 21.25 4 20.9 4 20.5V3.5C4 3.1 4.15 2.75 4.45 2.45C4.75 2.15 5.1 2 5.5 2H14.025L20 7.975V20.5C20 20.9 19.85 21.25 19.55 21.55C19.25 21.85 18.9 22 18.5 22H5.5ZM5.5 20.5H18.5V8.65L13.35 3.5H5.5V20.5Z",
    fill: "url(#paint0_linear_49_488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_488",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiastiss);
export default __webpack_public_path__ + "static/media/guiastiss.f82ba60f61c72b17551f4480988b37ce.svg";
export { ForwardRef as ReactComponent };